module.exports = __webpack_public_path__ + "static/media/logo.79bf2346.png";